import { render } from "./VueClientRecaptcha.vue?vue&type=template&id=f7a4c04c"
import script from "./VueClientRecaptcha.vue?vue&type=script&lang=js"
export * from "./VueClientRecaptcha.vue?vue&type=script&lang=js"

import "./VueClientRecaptcha.vue?vue&type=style&index=0&id=f7a4c04c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__